import {Button, closeDialog, openDialog, Tooltip} from 'platform/components';

import {MouseEventHandler} from 'react';

import {head, isEmpty, reject} from 'ramda';
import {isNilOrEmpty, isPositive} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {AssignMechanicType} from '@dms/shared-aftersales';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {useWorkshopUrl} from '../../../hooks/useWorkshopUrl';
import {AssignMechanicForm} from './AssignMechanicForm';

interface AssignMechanicProps extends TestIdProps {
  assignMechanics: (AssignMechanicType | null)[] | Nullish;
  jobId: string;
  competenceId: string;
  isDisabled?: boolean;
}

export function AssignMechanic(props: AssignMechanicProps) {
  const {orderId, serviceCaseId} = useWorkshopUrl();

  const onClick: MouseEventHandler = (event) => {
    event.stopPropagation();

    openDialog(
      <AssignMechanicForm
        orderId={orderId}
        serviceCaseId={serviceCaseId}
        serviceJobId={props.jobId}
        competenceId={props.competenceId}
        onClose={() => closeDialog('assignMechanic')}
        selectedMechanics={props.assignMechanics?.map((mechanic) => mechanic?.id ?? '') ?? []}
        data-testid={suffixTestId('dialog', props)}
      />,
      {
        id: 'assignMechanic',
        title: i18n.t('entity.orderRequest.labels.assignMechanic'),
        size: 'small',
      }
    );
  };

  const anotherCount = (props.assignMechanics?.length ?? 0) - 1;
  const allNames = props.assignMechanics?.map((mechanic) => mechanic?.name).join(', ');
  const buttonTitle = isEmpty(reject(isNilOrEmpty, props.assignMechanics ?? []))
    ? i18n.t('entity.orderRequest.labels.assignMechanic')
    : `${head(props.assignMechanics ?? [])?.name}${
        isPositive(anotherCount) ? ` +${anotherCount}` : ''
      }`;

  return (
    <Tooltip label={isEmpty(allNames) ? undefined : allNames} childrenWrapperDisplay="flex">
      <Button
        title={buttonTitle}
        leftIcon="social/person_add"
        variant="link"
        size="small"
        onClick={onClick}
        isDisabled={props.isDisabled}
        data-testid={props['data-testid']}
      />
    </Tooltip>
  );
}
